import { Bar } from "react-chartjs-2";

export default function BarChart({info}) {

  const data = {
    labels: ["18-24", "25-34", "35-44", "45-54", "55-64", "65+"],
    datasets: [
      {
        /* label: "Mujeres", */
        label: "Personas",
        backgroundColor: ["#004990","#BDBDBD"],
        borderColor: "none",
        maxBarThickness: 9,
        barThickness: 20,
        data: info
        /* data: [126.19, 50.12, 89.6, 89.6, 23.22, 66.54], */
      },
      /* {
        label: "Hombres",
        backgroundColor: "#004990",
        borderColor: "none",
        maxBarThickness: 7,
        barThickness: 20,
        data: [327.16, 126.19, 50.12, 89.6, 23.22, 66.54],
      } */
    ],
  };

  const opciones = {
    maintainAspecRatio: false,
    responsive: true,
    cutout: "90%",
    plugins: {
      tooltip: {
        // usePointStyle: true,
        // backgroundColor: "#FFF",
        boxWidth: 10,
        boxHeight: 10,
        textDirection: "rtl",
        bodyColor: "#FFF",
        caretSize: 10,
        bodyFont: {
          family: "Montserrat"
        }
      },
      legend: {
        display: false,
        labels:{
          font: {
            size: 14,
            family: "Montserrat"
          }
        }
      },
    },
  };

  return (
    <div style={{ width: "535px", maxHeight: "233px",  minHeight: "233px", marginTop: "24px" }}>
      <Bar data={data} options={opciones} />
    </div>
  );
}
